var _ellipse, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorbike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.58334,
    cy: 14.667,
    rx: 2.75,
    ry: 2.75,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4167,
    cy: 14.667,
    r: 2.75,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.3337C6.59886 12.3337 6.375 12.5575 6.375 12.8337C6.375 13.1098 6.59886 13.3337 6.875 13.3337V12.3337ZM11.4583 12.8337V13.3337C11.5909 13.3337 11.7181 13.281 11.8119 13.1872L11.4583 12.8337ZM15.125 9.16699L15.4786 9.52055C15.6216 9.37755 15.6643 9.16249 15.5869 8.97565C15.5095 8.78881 15.3272 8.66699 15.125 8.66699V9.16699ZM5.5 8.66699C5.22386 8.66699 5 8.89085 5 9.16699C5 9.44313 5.22386 9.66699 5.5 9.66699V8.66699ZM6.52145 12.4801C6.32618 12.6754 6.32618 12.9919 6.52145 13.1872C6.71671 13.3825 7.03329 13.3825 7.22855 13.1872L6.52145 12.4801ZM10.8952 9.52055C11.0905 9.32528 11.0905 9.0087 10.8952 8.81344C10.7 8.61818 10.3834 8.61818 10.1881 8.81344L10.8952 9.52055ZM6.875 13.3337H11.4583V12.3337H6.875V13.3337ZM11.8119 13.1872L15.4786 9.52055L14.7714 8.81344L11.1048 12.4801L11.8119 13.1872ZM15.125 8.66699H5.5V9.66699H15.125V8.66699ZM7.22855 13.1872L10.8952 9.52055L10.1881 8.81344L6.52145 12.4801L7.22855 13.1872Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 5.5H13.75L15.125 8.25L16.9583 11.9167",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorbike);
export default __webpack_public_path__ + "static/media/motorbike.2aeb315d50a707c21e3dd4c0bdbd083e.svg";
export { ForwardRef as ReactComponent };